import { queryOptions } from '@tanstack/react-query'
import { ApiError, apiGet, rememberSessionKind, unwrap } from '@/shared/api'
import { type Me, MeSchema, type Session, sessionFromMe } from '../model/schema'

export const sessionKeys = {
  me: ['session', 'me'] as const,
}

// Identity читаем у своего бэкенда (same-origin): хаб отдаёт CORS-заголовки только
// своему фронту, и cross-origin /me из браузера не прочитать. Ту же cookie бэкенд
// верифицирует локально по JWKS.
// 401 = «сессии нет» → null (не ошибка): AuthGate уводит на единый вход хаба.
// 404 = бэкенд ещё без customer-контура: продукт остаётся рабочим для сотрудника,
// личность берётся из доменного `/api/employees/me`. Прочие ошибки — наверх, их
// нельзя путать с «не залогинен».
export const sessionQueryOptions = queryOptions({
  queryKey: sessionKeys.me,
  queryFn: async (): Promise<Session | null> => {
    let raw: unknown
    try {
      raw = unwrap<Me>(await apiGet('/auth/me'))
    } catch (error) {
      if (!(error instanceof ApiError)) throw error
      if (error.status === 401) return null
      if (error.status !== 404) throw error
      raw = employeeFallback(unwrap<{ id: string; name?: string }>(await apiGet('/employees/me')))
    }
    const session = sessionFromMe(MeSchema.parse(raw))
    // Единственное место, где контур виден фронту: дальше по нему выбирается
    // ручка продления на 401 (00-architecture § 3).
    rememberSessionKind(session.kind)
    return session
  },
  staleTime: 60_000,
})

function employeeFallback(employee: { id: string; name?: string }): Me {
  return { sub: employee.id, kind: 'employee', ...(employee.name ? { name: employee.name } : {}) }
}
